import { render, staticRenderFns } from "./centerMenu.vue?vue&type=template&id=6d9afcc2&scoped=true&"
import script from "./centerMenu.vue?vue&type=script&lang=js&"
export * from "./centerMenu.vue?vue&type=script&lang=js&"
import style0 from "./centerMenu.vue?vue&type=style&index=0&id=6d9afcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9afcc2",
  null
  
)

export default component.exports